import React, { useEffect, useContext, useState } from 'react';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import Menu from '../layout/Menu';

import DashboardPage from '../features/DashboardPage';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Guarded from './AppMainGuarded';
import NotFound from '../utils/NotFound';


const AppMain = (prop: any) => {

    return (
        <Router>
            {/* <Switch> */}
            <React.Fragment>
                <div id="wrapper">
                    <Header />
                    <Menu data={prop} />
                    <div className="content-wrapper">
                        <Switch>
                            <Guarded allowedUrl={prop.allowedUrl} path="/" ></Guarded>
                            <Route component={NotFound} />
                        </Switch>
                    </div>
                    <Footer />
                </div>
            </React.Fragment>
            {/* </Switch>    */}
        </Router >

    );
}

export default AppMain;